module.exports = __webpack_public_path__ + "img/26_196.ee82ef32.png";